import './SceneThumbnails.css';

interface SceneThumbnailData {
  id: string;
  order_number: number;
  image_url?: string;
  thumbnail_url?: string;
  /** 動画素材のサムネイル。あればフレーム画像より優先して表示する */
  video_thumbnail_url?: string | null;
}

interface SceneThumbnailsProps {
  scenes: SceneThumbnailData[];
  maxThumbnails?: number;
  aspectRatio?: string;
}

export function SceneThumbnails({ scenes, maxThumbnails = 5, aspectRatio }: SceneThumbnailsProps) {
  // 表示するシーンを制限
  const displayScenes = scenes.slice(0, maxThumbnails);
  const hasMore = scenes.length > maxThumbnails;
  const isPortrait = aspectRatio === '9:16';
  const isSquare = aspectRatio === '1:1';
  const cssAspectRatio = isPortrait ? '9 / 16' : isSquare ? '1 / 1' : '16 / 9';
  const shapeClass = isPortrait ? 'portrait' : isSquare ? 'square' : '';

  return (
    <div className="scene-thumbnails">
      {displayScenes.map((scene, index) => (
        <SceneThumbnail
          key={scene.id}
          scene={scene}
          sceneNumber={index + 1}
          cssAspectRatio={cssAspectRatio}
          shapeClass={shapeClass}
        />
      ))}
      {hasMore && (
        <div className={`scene-thumbnail more-indicator ${shapeClass}`} style={{ aspectRatio: cssAspectRatio }}>
          <span>+{scenes.length - maxThumbnails}</span>
        </div>
      )}
    </div>
  );
}

interface SceneThumbnailProps {
  scene: SceneThumbnailData;
  sceneNumber: number;
  cssAspectRatio: string;
  /** 'portrait' | 'square' | '' (16:9)。幅は SceneThumbnails.css 側で比率ごとに決める */
  shapeClass: string;
}

function SceneThumbnail({ scene, sceneNumber, cssAspectRatio, shapeClass }: SceneThumbnailProps) {
  // 画像URLの優先順位: video_thumbnail_url > thumbnail_url > image_url > プレースホルダー
  const imageUrl = scene.video_thumbnail_url || scene.thumbnail_url || scene.image_url;

  if (imageUrl) {
    return (
      <div className={`scene-thumbnail ${shapeClass}`} style={{ aspectRatio: cssAspectRatio }}>
        <img
          src={imageUrl}
          alt={`シーン ${sceneNumber}`}
          loading="lazy"
          onError={(e) => {
            // 画像読み込みエラー時はプレースホルダーを表示
            e.currentTarget.style.display = 'none';
            const placeholder = e.currentTarget.nextElementSibling as HTMLElement;
            if (placeholder) {
              placeholder.style.display = 'flex';
            }
          }}
        />
        <div className="scene-thumbnail-placeholder" style={{ display: 'none' }}>
          <span className="scene-number">{sceneNumber}</span>
        </div>
        <div className="scene-number-badge">{sceneNumber}</div>
      </div>
    );
  }

  // プレースホルダー表示
  return (
    <div className={`scene-thumbnail ${shapeClass}`} style={{ aspectRatio: cssAspectRatio }}>
      <div className="scene-thumbnail-placeholder">
        <span className="scene-number">{sceneNumber}</span>
      </div>
    </div>
  );
}
